import { createCable } from "@anycable/web";

export const cable = createCable();
